import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import './App.scss';

import Routing from './Routes';
import { firebaseCloudMessaging } from './utils/firebase';

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          console.info('fcm_Token', fcmToken);
        }
      } catch (error) {
        console.error(error);
      }
    }
    setToken();

    // Event listener that listens for the push notification event in the background
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        try {
          event?.source?.postMessage('Hi client');
          console.info('event for the service worker', event);

          return toast(
            <div style={{ height: '100%' }}>
              <div style={{ color: '#820000' }} onClick={() => navigate('/recieved-notifications')}>
                {event?.data?.data?.title || ''}
              </div>
              <div
                style={{ color: '#1d1d1d', paddingTop: '10px' }}
                onClick={() => navigate('/recieved-notifications')}
              >
                {event?.data?.data?.message || ''}
              </div>
            </div>
          );
        } catch (e) {
          console.error(e, 'error');
          return e;
        }
      });
    }

    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'notifications' }).then(function (notificationPerm) {
        notificationPerm.onchange = function () {
          if (notificationPerm.state === 'granted') {
            setToken();
            if (window) {
              window.location.reload();
            }
          }
        };
      });
    }
    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', (e) => console.info(e));
      }
    };
  }, []);

  return <Routing />;
};

export default App;
